import styled from 'styled-components'
import { MultiSelectCustomUnstyled } from './unstyled'

export const MultiSelectCustom = styled(MultiSelectCustomUnstyled)`
  display: ${props => (props.hidden ? 'none' : 'flex')};
  height: 40px;
  line-height: 40px;

  label {
    color: ${props => (props.theme.colors || {}).regentGray || '#7F8FA4'};
    font-weight: 600;
    margin-right: 10px;
    width: ${props => (props.label === 'Sort by' ? '50px' : 'auto')};
  }
`
